import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  Modal,
  Space,
  Descriptions,
  Avatar,
  Badge,
  notification,
} from "antd";
import {
  DeleteTwoTone,
  EditTwoTone,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import axios from "axios";
import AddOrUpdateAdmin from "./Modals/AdminModalAddEdit.js";

const { Text } = Typography;
const { confirm } = Modal;

const Admins = () => {
  const [data, setData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [action, setAction] = useState("");
  const [record, setRecord] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRefetch = () => {
    setRefetch(!refetch);
  };

  const showDeleteConfirm = (adminData) => {
    confirm({
      title: `Voulez-vous supprimer l'admin ${adminData.name} ?`,
      icon: <ExclamationCircleOutlined />,
      async onOk() {
        setIsLoading(true);
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/admins/${adminData._id}`);
          handleRefetch();
          notification.success({
            message: "Admin supprimé avec succès",
          });
        } catch (err) {
          console.error(err);
          notification.error({
            message: "Erreur lors de la suppression",
          });
        } finally {
          setIsLoading(false);
        }
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      render: (id) => <Text ellipsis>{id}</Text>,
    },
    {
      title: "Nom",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <Badge
          status={type === "admin" ? "success" : "success"}
          text={type.toUpperCase()}
        />
      ),
    },
    {
      title: "Etablissement",
      dataIndex: "IdEtab",
      key: "IdEtab",
      render: (text, record) => (
        <Space>
          <Avatar
            size="small"
            src={process.env.REACT_APP_API_URL + "/upload/" + text?.avatar}
            icon={!text?.avatar && <UserOutlined />}
          />
          <Text strong>{text?.name ?? "NA"}</Text>
        </Space>
      ),
    },
    {
      title: "Statut",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Badge
          status={status === "active" ? "success" : "error"}
          text={status}
        />
      ),
    },
    {
      title: "Actions",
      key: "action",
      width: 200,
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              setVisible(true);
              setRecord(record);
              setAction("EDIT");
            }}
          >
            <EditTwoTone />
          </Button>

          <Button
            onClick={() => {
              setIsModalOpen(true);
              setRecord(record);
            }}
          >
            <InfoCircleOutlined />
          </Button>

          <Button danger onClick={() => showDeleteConfirm(record)}>
            <DeleteTwoTone twoToneColor="red" />
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const fetchAdmins = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/admins`);
        if (response.data) {
          setData(response.data);
        } else {
          notification.error({ message: "Aucune donnée trouvée" });
        }
      } catch (error) {
        notification.error({
          message: "Erreur de chargement des données",
          description: error.message,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdmins();
  }, [refetch]);

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            loading={isLoading}
            className="criclebox tablespace mb-24"
            title="Gestion des Admins"
            extra={
              <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                  setRecord({});
                  setAction("ADD");
                }}
              >
                Ajouter un Admin
              </Button>
            }
          >
            <Table
              columns={columns}
              dataSource={data}
              pagination={{ pageSize: 10 }}
              rowKey="_id"
              scroll={{ x: true }}
            />
          </Card>
        </Col>
      </Row>

      <AddOrUpdateAdmin
        visible={visible}
        record={action === "EDIT" ? record : {}}
        refetch={handleRefetch}
        type={action}
        onCancel={() => setVisible(false)}
      />

      <Modal
        title="Détails de l'Admin"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Nom">
            <Space>
              <Avatar
                style={{ backgroundColor: "#87d068" }}
                icon={<UserOutlined />}
              />
              <Text strong>{record?.name || "Non spécifié"}</Text>
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {record?.email || <Badge status="error" text="Non spécifié" />}
          </Descriptions.Item>
          <Descriptions.Item label="Type">
            <Badge
              status={record?.type === "admin" ? "success" : "default"}
              text={record?.type || "admin"}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Statut">
            <Badge
              status={record?.status === "active" ? "success" : "error"}
              text={record?.status || "inactive"}
            />
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </div>
  );
};

export default Admins;
